import { render, staticRenderFns } from "./lookRemark.vue?vue&type=template&id=619d3934&scoped=true"
import script from "./lookRemark.vue?vue&type=script&lang=ts"
export * from "./lookRemark.vue?vue&type=script&lang=ts"
import style0 from "./lookRemark.vue?vue&type=style&index=0&id=619d3934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d3934",
  null
  
)

export default component.exports